import React, { memo } from 'react';
import { PageCompactItem } from '@redlink/components/muscles';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  clearCache,
  getUserPagesQuery,
  signInPageQuery,
  useMutation,
  useQuery,
} from '@redlink/services';
import AsyncStorage from '@react-native-community/async-storage';
import { IconPlus, Space } from '../atoms';
import { useLocale } from '@redlink/assets/locale';
import { IconButtonItem } from '../molecules';

export const PageCompactList = memo(
  ({ onSelect, onAddPress, currentPageName }) => {
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();

    const {
      data: { UserPages: { active = [] } = {} },
    } = useQuery(getUserPagesQuery);

    const [signInPage, { loading: signInPageIsBusy }] = useMutation(
      signInPageQuery,
      {
        done: async ({ SignInPage: { token } }) => {
          await clearCache();
          await AsyncStorage.setItem('@token', token);
          window.location.reload();
        },
      }
    );

    return (
      <View style={styles.container}>
        {active.filter(({ pageName }) => pageName !== currentPageName).map(
          (item) => {
            return (
              <PageCompactItem
                {...{ item }}
                onSelect={() => {
                  onSelect(item);
                  signInPage({ pageId: item.id });
                }}
              />
            );
          }
        )}
        <Space size={4} />
        <IconButtonItem title={dictionary.addPage} onPress={onAddPress}>
          <IconPlus color={colors.black} size={24} />
        </IconButtonItem>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {},
}));
